<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>订单确认</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="panel mt-20">
      <el-form :model="order" label-position="left" size="mini">
        <el-form-item label="最终客户">
          <customer-select
            :val="order.customer_id"
            @change="order.customer_id = $event"
          ></customer-select>
          <div
            class="font-12 text-danger"
            style="line-height: 1.4em; margin-top: 5px"
          >
            请尽量选择最终客户，作为自有客户确认的重要依据
          </div>
        </el-form-item>
        <el-form-item label="最终用途">
          <el-select
            v-model="order.usage"
            size="small"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in customerUsages"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
          <el-input
            v-if="order.usage == '无'"
            style="width: 220px; margin-left: 10px"
            size="small"
            v-model="order.customize_usage"
            placeholder="手动填写"
            maxlength="50"
          ></el-input>

          <div
            class="font-12 text-info"
            style="line-height: 1.4em; margin-top: 5px"
            v-if="order.usage"
          >
            用途说明：{{
              customerUsages.filter((item) => item.name == order.usage)[0].desc
            }}
          </div>
        </el-form-item>

        <!-- <el-form-item v-if="order.usage == '无'">
          <el-input
            size="small"
            v-model="order.customize_usage"
            placeholder="请输入"
            maxlength="50"
          ></el-input>
        </el-form-item> -->

        <el-form-item label="收货信息">
          <div class="receive-info">
            <template v-if="order.receive_address_id">
              <span class="mr-20">{{ order.receive_address.contact_name }}</span
              ><span class="mr-20"
                >{{ codeToText[order.receive_address.province] }}
                {{ codeToText[order.receive_address.city] }}
                {{ codeToText[order.receive_address.county] }}
                {{ order.receive_address.detail }}</span
              ><span class="mr-20">
                {{ order.receive_address.contact_phone }}
              </span>
            </template>
            <el-button type="text" size="mini" @click="handleEditAddress(1)">{{
              order.receive_address_id ? '修改' : '新增收货地址'
            }}</el-button>
          </div>
        </el-form-item>

        <el-form-item
          label="是否批量订单"
          v-if="
            order.items.filter((item) => item.department_id == 1).length > 0
          "
        >
          <div class="mt-5" style="display: inline-block">
            <el-radio v-model="order.bq" :label="1" border>否</el-radio>
            <el-radio v-model="order.bq" :label="2" border>是</el-radio>
          </div>
        </el-form-item>

        <el-form-item label="商品">
          <router-link to="/dashboard/shop/carts" class="back-btn"
            >返回修改购物车</router-link
          >
          <el-table
            v-if="!isMobile()"
            :data="order.items"
            border
            size="mini"
            style="width: 100%"
          >
            <el-table-column align="left" label="商品" min-width="200px">
              <template slot-scope="scope">
                <div class="item-container">
                  <div class="flex-row">
                    <auth-img
                      tag="el-image"
                      :src="scope.row.cover"
                      style="width: 84px; height: 84px"
                      fit="cover"
                      ><div slot="error" class="image-slot">
                        暂无图片
                      </div></auth-img
                    >
                  </div>
                  <div class="item-info">
                    <!-- <span>{{ scope.row.name }}</span> -->
                    <!-- <span>{{ scope.row.commodity_category_name }}</span> -->
                    <span class="part-number"
                      >{{ scope.row.part_number }}
                      <i class="font-12 font-normal"
                        >（{{ scope.row.type_name }}）</i
                      ></span
                    >
                    <span>
                      <el-tag size="mini">{{
                        scope.row.commodity_category_name
                      }}</el-tag>
                    </span>
                    <span class="item-desc">{{ scope.row.description }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="单价（元）">
              <template slot-scope="scope">{{
                scope.row.price.toFixed(2)
              }}</template>
            </el-table-column>
            <el-table-column align="center" label="数量" prop="number">
            </el-table-column>

            <el-table-column align="center" label="小计（元）">
              <template slot-scope="scope">
                ￥{{ (scope.row.number * scope.row.price).toFixed(2) }}
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <!-- <el-form-item label="支付方式">
          <el-radio-group v-model="order.pay_type" size="small">
            <el-radio border :label="1">线下支付</el-radio>
            <el-radio border :label="2" disabled>银联支付（待开放）</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <!-- <el-form-item label="发票信息">
          <div class="invoice">
            <template v-if="order.invoice_id">
              <span class="mr-20">{{
                order.invoice.category == 1 ? '普通发票' : '增值税专用发票'
              }}</span>
              <span class="mr-20">{{
                order.invoice.letterhead_category == 2 ||
                order.invoice.category == 2
                  ? order.invoice.company_name
                  : order.invoice.head_name
              }}</span>
              <span class="mr-20">{{
                order.invoice.content_type == 1 ? '商品明细' : '商品类别'
              }}</span>
            </template>
            <span class="mr-20 font-12" v-else>不开发票</span>
            <el-button type="text" size="mini" @click="handleInvoiceEdit">{{
              order.invoice_id ? '修改' : '新增发票'
            }}</el-button>
          </div>
        </el-form-item> -->
        <el-form-item label="发票邮寄信息">
          <template v-if="order.invoice_address_id">
            <span class="mr-20">{{ order.invoice_address.contact_name }}</span
            ><span class="mr-20"
              >{{ codeToText[order.invoice_address.province] }}
              {{ codeToText[order.invoice_address.city] }}
              {{ codeToText[order.invoice_address.county] }}
              {{ order.invoice_address.detail }}</span
            ><span class="mr-20">
              {{ order.invoice_address.contact_phone }}
            </span>
          </template>
          <el-button type="text" size="mini" @click="handleEditAddress(2)">{{
            order.invoice_address_id ? '修改' : '新增发票寄送地址'
          }}</el-button>
        </el-form-item>
        <el-form-item label="买家留言">
          <el-input
            type="textarea"
            v-model="order.remark"
            :rows="3"
            style="width: 300px"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="option-bar">
        <div class="optipn-fight">
          <div class="fix-width">
            <span>
              <b style="color: #e4393c">{{ commodityInfo.count }}</b>
              件商品，</span
            >商品总额（不含税）：<span>￥{{ commodityInfo.noTaxPrice }}</span>
          </div>
          <div class="fix-width">
            税费：<span>￥{{ commodityInfo.taxPrice }}</span>
          </div>
          <div class="pay-amount mt-20 fix-width">
            应付金额（含税）：<span>￥{{ commodityInfo.totalPrice }}</span>
          </div>
          <div class="font-12" v-if="order.receive_address_id">
            <span
              >寄送至：{{ codeToText[order.receive_address.province] }}
              {{ codeToText[order.receive_address.city] }}
              {{ codeToText[order.receive_address.county] }}
              {{ order.receive_address.detail }}</span
            >
            <span class="ml-20"
              >收货人：{{ order.receive_address.contact_name }}
              {{ order.receive_address.contact_phone }}</span
            >
          </div>
          <div class="font-12" v-else>
            <span>寄送至：-</span><span class="ml-20">收货人：-</span>
          </div>
          <div class="mt-10">
            <el-button
              type="danger"
              @click="handleOrderNew"
              :loading="submitLoading"
              >提交订单</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <address-former
      :model="address"
      :show.sync="addressFormVisible"
      @created="addressCreatedCallback"
      @updated="addressUpdatedCallback"
    ></address-former>

    <invoice-former
      :model="invoice"
      :show.sync="invoiceFormVisible"
      @created="invoiceCreatedCallback"
      @updated="invoiceUpdatedCallback"
    ></invoice-former>
  </div>
</template>

<script>
import CustomerSelect from '@/components/select/customer_select'
import {
  commodityOrderConfirm,
  createCommodityOrder,
  createAddress,
} from '@/service/getData'
import { isMobile } from '../../../util'
import AddressFormer from './address_former'
import InvoiceFormer from './invoice_former'
import { CodeToText } from '@/util/area_tool'
import { clone } from '@/util'
import { CustomerUsages } from '@/config/global'

export default {
  components: {
    CustomerSelect,
    AddressFormer,
    InvoiceFormer,
  },
  data() {
    return {
      submitLoading: false,
      codeToText: CodeToText,
      isMobile,
      list: [],
      order: { items: [], bq: 1 },
      address: {
        category: 1,
        area: [],
        province: '',
        city: '',
        county: '',
        detail: '',
        contact_name: '',
        contact_phone: '',
      },
      addressFormVisible: false,
      invoice: {},
      invoiceFormVisible: false,
      customerUsages: CustomerUsages,
    }
  },
  created() {
    this.getOrderInfo()
  },
  watch: {
    'order.bq': 'getOrderPrice',
  },
  computed: {
    commodityInfo() {
      let res = {
        count: 0,
        noTaxPrice: 0,
        taxPrice: 0,
        totalPrice: 0,
      }
      this.order.items.map((item) => {
        res.count += item.number
        res.noTaxPrice += item.number * item.price
      })
      res.taxPrice = (res.noTaxPrice * 0.13).toFixed(2)
      res.totalPrice = (res.noTaxPrice + Number(res.taxPrice)).toFixed(2)
      res.noTaxPrice = res.noTaxPrice.toFixed(2)
      return res
    },
  },
  methods: {
    async getOrderInfo() {
      let res = await commodityOrderConfirm({ bq: this.order.bq })
      this.order = res.data
    },

    async getOrderPrice() {
      let res = await commodityOrderConfirm({ bq: this.order.bq })
      this.order.items = res.data.items
    },

    handleInvoiceEdit() {
      let invoice = clone(this.order.invoice)
      if (invoice.category == 0) {
        invoice.category = 1
        invoice.letterhead_category = 2
        invoice.content_type = 1
      }

      if (invoice.commodity_order_id > 0) {
        invoice.id = 0
        invoice.commodity_order_id = 0
      }

      invoice.area = [
        invoice.contact_province,
        invoice.contact_city,
        invoice.contact_county,
      ]

      this.invoice = invoice
      this.invoiceFormVisible = true
    },
    invoiceCreatedCallback(data) {
      this.order.invoice_id = data.id
      this.order.invoice = data
    },
    invoiceUpdatedCallback(data) {
      this.order.invoice = data
    },

    handleEditAddress(category) {
      //category 1-收货地址 2 - 发票寄送地址
      this.addressFormVisible = true
      if (
        (category == 1 && this.order.receive_address_id) ||
        (category == 2 && this.order.invoice_address_id)
      ) {
        this.$nextTick(() => {
          this.address =
            category == 1
              ? clone(this.order.receive_address)
              : clone(this.order.invoice_address)

          if (this.address.commodity_order_id > 0) {
            this.address.id = 0
            this.address.commodity_order_id = 0
          }
          this.address.area = [
            this.address.province,
            this.address.city,
            this.address.county,
          ]
        })
      } else {
        this.address = {
          category: category,
          area: [],
          province: '',
          city: '',
          county: '',
          detail: '',
          contact_name: '',
          contact_phone: '',
        }
      }
    },

    addressCreatedCallback(data) {
      if (data.category == 1) {
        this.order.receive_address_id = data.id
        this.order.receive_address = data

        if (!this.order.invoice_address_id) {
          this.createInvoiceAddress(data)
        }
      } else {
        this.order.invoice_address_id = data.id
        this.order.invoice_address = data
      }
    },
    async createInvoiceAddress(data) {
      let params = clone(data)
      params.id = 0
      params.category = 2
      let res = await createAddress(params)
      if (res.code == 0) {
        this.order.invoice_address_id = res.data.id
        this.order.invoice_address = res.data
      }
    },
    addressUpdatedCallback(data) {
      if (data.category == 1) {
        this.order.receive_address = data
      } else {
        this.order.invoice_address = data
      }
    },

    async handleOrderNew() {
      if (this.submitLoading) return
      // if (!this.order.customer_id) {
      //   this.$alert('请选择最终客户')
      //   return
      // }

      if (!this.order.usage) {
        this.$alert('请选择最终用途')
        return
      }

      if (this.order.usage == '无' && !this.order.customize_usage) {
        this.$alert('请选择或填写最终用途')
        return
      }

      if (!this.order.receive_address_id) {
        this.$alert('请填写收货信息')
        return
      }

      this.order.no_tax_price = Number(this.commodityInfo.noTaxPrice)
      this.order.tax_fee = Number(this.commodityInfo.taxPrice)
      this.order.total_price = Number(this.commodityInfo.totalPrice)

      if (this.order.total_price < 4000) {
        this.$alert('订单总价低于 4000元 无法创建订单！', '温馨提示')
        return
      }

      this.submitLoading = true

      this.order.items.map((item) => {
        delete item.description
        return item
      })

      let res = await createCommodityOrder(this.order)
      if (res.code == 0) {
        this.$emit('updateGoingCount')
        if (res.data.orderCount > 1) {
          this.$alert(`您的订单已被拆分为${res.data.orderCount}条订单！`)
          this.$router.push(`/dashboard/shop/pending_orders`)
          return
        }

        if (res.data.order.status == 2) {
          this.$router.push(
            `/dashboard/shop/approve_orders/${res.data.order.id}`
          )
        } else {
          this.$router.push(
            `/dashboard/shop/pending_orders/${res.data.order.id}`
          )
        }
      } else {
        this.submitLoading = false
      }
    },
  },
}
</script>

<style scoped>
.item-container {
  display: flex;
  align-content: flex-start;
}
.item-info {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}
.optipn-fight {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: right;
}
.optipn-fight span {
  margin-bottom: 5px;
}
.option-bar {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  border-top: 1px solid #ebeef5;
  padding-top: 20px;
}
.optipn-fight div.fix-width span {
  min-width: 130px;
  text-align: right;
  display: inline-block;
}
.pay-amount {
  color: #e4393c;
}
.pay-amount span {
  font-size: 1.5em;
  font-weight: bold;
}
/deep/.el-form-item__label {
  width: 100%;
}
.back-btn {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 12px;
  display: flex;
  justify-content: flex-end;
}
.part-number {
  color: #3d3d3d;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
}
.item-desc {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 4px;
  height: 36px;
  font-size: 12px;
  color: #666;
  line-height: 1.4em;
}
</style>